import { Stack } from "@mui/material";
import React from "react";
import { colors } from "../../../../utils";
import { ASSETS } from "../../../../utils/config";
import { TextView } from "../../../../components";
import RefreshIcon from "@mui/icons-material/Refresh";
function MobileError() {
  return (
    <Stack
      style={{
        // alignItems: "center",
        padding: "10px",
        // backgroundColor: "#F6F7F9",
        backgroundColor: "white",
        borderRadius: "5px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Stack
        display={"flex"}
        flexDirection={"row"}
        style={{ width: "100%", padding: "5px" }}
        alignItems={"center"}
      >
        {/* <UserImage image={profile_image} size={60} /> */}
        <img
          src={ASSETS.ErrorImg}
          alt="Eror"
          style={{ height: "60px", width: "60px" }}
        />

        <Stack ml={1}>
          <TextView
            style={{
              color: colors.primary,
              fontWeight: "700",
              fontSize: "20px",
            }}
          >
            Failed to Load <br></br> this Screen
          </TextView>
        </Stack>
      </Stack>
      <TextView
        style={{
          color: colors.darkGrey,
          fontSize: "16px",
          margin: "5px",
        }}
      >
        Looks like there is some problem from our end, refresh and try again!
      </TextView>
      <Stack
        onClick={() => window.location.reload()}
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"center"}
        alignItems={"center"}
        sx={{
          border: "0.5px solid #E1E1E1",
          borderRadius: 4,
          p: 0.5,
          marginRight: "50vw",
          my: 1,
        }}
      >
        <RefreshIcon style={{ fontSize: "13px" }} />
        <TextView
          style={{
            color: colors.darkGrey,
            fontSize: "13px",
            marginLeft: "4px",
          }}
        >
          Refresh
        </TextView>
      </Stack>
    </Stack>
  );
}

export default MobileError;
